import React from 'react'
import Pt from 'prop-types'

import './Meter.css'

export default function Meter({
  result = {},
}) {
  return (
    <div className="password-meter">
      <meter
        min={-0.05}
        max={4}
        optimum={3}
        value={result.score || 0}
      ><span /></meter>
    </div>
  )
}

Meter.propTypes = {
  result: Pt.shape({
    score: Pt.number.isRequired,
  }),
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/Password/Meter.jsx